import axiosInstance from './AxiosInstance';

const API_URL = 'jobtitles';

export const getJobTitles = async () => {
    try {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Error fetching jobtitles', error);
        throw error;
    }
};

export const getJobTitleById = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/view/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching jobtitle with id ${id}`, error);
        throw error;
    }
};

export const createJobTitle = async (jobtitle) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/add`, jobtitle);
        return response.data;
    } catch (error) {
        console.error('Error creating jobtitle', error);
        throw error;
    }
};

export const updateJobTitle = async (id, jobtitle) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/update`, { id: id, ...jobtitle });
        return response.data;
    } catch (error) {
        console.error(`Error updating jobtitle with id ${id}`, error);
        throw error;
    }
};

export const deleteJobTitle = async (id) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/delete/`, { id: id });
        return response.data;
    } catch (error) {
        console.error(`Error deleting jobtitle with id ${id}`, error);
        throw error;
    }
};

